import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Landing() {
  const { t } = useTranslation();
  const [smsCount, setSmsCount] = useState(1000);

  const whyChooseUs = [
    {
      icon: "/assets/img/UnmatchedReach.svg",
      title: "unmatched_reach",
      desc: "unmatched_reach_desc",
    },
    {
      icon: "/assets/img/SpeedReliability.svg",
      title: "speed_reliability",
      desc: "speed_reliability_desc",
    },
    {
      icon: "/assets/img/BuiltScale.svg",
      title: "built_scale",
      desc: "built_scale_desc",
    },
    {
      icon: "/assets/img/BrandTrust.svg",
      title: "brand_trust",
      desc: "brand_trust_desc",
    },
  ];

  const features = [
    {
      icon: "/assets/img/BulkTransactional.svg",
      title: "bulk_transactional",
      desc: "bulk_transactional_desc",
    },
    {
      icon: "/assets/img/MessageScheduling.svg",
      title: "message_scheduling",
      desc: "message_scheduling_desc",
    },
    {
      icon: "/assets/img/CustomSender.svg",
      title: "custom_sender",
      desc: "custom_sender_desc",
    },
    {
      icon: "/assets/img/APIIntegration.svg",
      title: "api_integration",
      desc: "api_integration_desc",
    },
    {
      icon: "/assets/img/DeliveryReportsAnalytics.svg",
      title: "delivery_reports_analytics",
      desc: "delivery_reports_analytics_desc",
    },
    {
      icon: "/assets/img/earthfill.svg",
      title: "reliable_support_infrastructure",
      desc: "reliable_support_infrastructure_desc",
    },
  ];

  const pricingPlans = [
    {
      key: "starter",
      price: "13.99",
      range: { type: "up_to", value: "1,000" },
      features: [
        "bulk_SMS",
        "transactional_SMS",
        "custom_sender_ID",
        "basic_reports",
        "email_support",
      ],
    },
    {
      key: "growth",
      price: "11.99",
      range: { type: "text", value: "1,001 – 10,000 SMS" },
      features: [
        "bulk_SMS",
        "transactional_SMS",
        "custom_sender_ID",
        "advanced_reports",
        "priority_support",
      ],
    },
    {
      key: "business",
      price: "9.99",
      range: { type: "text", value: "10,001 – 50,000 SMS" },
      features: [
        "bulk_SMS",
        "transactional_SMS",
        "custom_sender_ID",
        "advanced_reports",
        "priority_support",
      ],
    },
    {
      key: "enterprise",
      price: "8.40",
      range: { type: "text", value: "50,000+ SMS" },
      features: [
        "bulk_SMS",
        "transactional_SMS",
        "custom_sender_ID",
        "advanced_reports",
        "dedicated_support",
      ],
    },
  ];

  const planStyles = {
    starter: {
      color: "blue",
      tagline: "starter_tagline",
      icon: <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z" />,
    },
    growth: {
      color: "green",
      tagline: "growth_tagline",
      featured: true,
      icon: <path d="M6 20V14M12 20V8M18 20V4" />,
    },
    business: {
      color: "orange",
      tagline: "business_tagline",
      icon: (
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
      ),
    },
    enterprise: {
      color: "purple",
      tagline: "enterprise_tagline",
      icon: (
        <path d="M3 21h18M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16M9 7h1M14 7h1M9 11h1M14 11h1M9 15h1M14 15h1" />
      ),
    },
  };

  const SMS_STEP = 100;
  const formatKz = (value) =>
    value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const VAT_RATE = 0.14;
  const getPlanForCount = (count) => {
    if (count <= 1000) return pricingPlans[0];
    if (count <= 10000) return pricingPlans[1];
    if (count <= 50000) return pricingPlans[2];
    return pricingPlans[3];
  };
  const selectedPlan = getPlanForCount(smsCount);
  const pricePerSms = parseFloat(selectedPlan.price);
  const subtotal = smsCount * pricePerSms;
  const vatAmount = subtotal * VAT_RATE;
  const totalWithVat = subtotal + vatAmount;

  return (
    <>
      <section id="hero" className="heroSectionOuter">
        <div className="container-fluid maxContainerSection mainHeaderPadding">
          <div className="row">
            <div className="col-md-7 heroLeftSection">
              <h2 className="m-0 h2Class">
                {t("your_business")} <span>{t("smshub")}</span>
              </h2>
              <p className="m-0 peraClass">{t("heroBanner_desc")}</p>
              <div>
                <div className="heroCheckRate">
                  <img src="/assets/img/Check.svg" alt="" />
                  <p className="m-0">{t("sms_open_rate")}</p>
                </div>
                <div className="heroCheckRate">
                  <img src="/assets/img/Check.svg" alt="" />
                  <p className="m-0">{t("works_without_internet")}</p>
                </div>
                <div className="heroCheckRate">
                  <img src="/assets/img/Check.svg" alt="" />
                  <p className="m-0">{t("fast_secure_scalable")}</p>
                </div>
              </div>
              <div>
                <Link
                  to="https://app.smshubangola.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="startTrialBtn">
                    {t("start_free_trial")}
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-md-5">
              <div className="heroRightSideImage">
                <img
                  src="/assets/img/smartphone.png"
                  alt=""
                  className="HeroImageRight img-fluid"
                />
                <img
                  src="/assets/img/smartphoneEffect.png"
                  alt=""
                  className="ShadeImage img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="whySmsHub" className="commonColor">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12">
              <div className="contentHeaderSection">
                <div className="headerSpan">{t("why_smshub")}</div>
                <h2 className="m-0 h2Class">{t("why_smshub_title")}</h2>
                <p className="m-0 peraClass">{t("why_smshub_desc")}</p>
              </div>
            </div>
          </div>
          <div className="row">
            {whyChooseUs.map((item, index) => (
              <div className="col-md-3" key={index}>
                <div className="whySectionContent">
                  <div className="whySectionContentHeader">
                    <img src={item.icon} alt="" />
                  </div>

                  <div className="whySectionContentBottom">
                    <h6 className="m-0">{t(item.title)}</h6>
                    <p className="m-0">{t(item.desc)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="features">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12">
              <div className="contentHeaderSection">
                <div className="headerSpan">{t("features")}</div>
                <h2 className="m-0 h2Class">{t("features_title")}</h2>
                <p className="m-0 peraClass">{t("features_desc")}</p>
              </div>
            </div>
          </div>

          <div className="row">
            {features.map((feature, index) => (
              <div className="col-md-4 featureSectionRow" key={index}>
                <div className="featureSection">
                  <div>
                    <img src={feature.icon} alt="" />
                  </div>

                  <div className="fetureTextContent">
                    <h6 className="m-0">{t(feature.title)}</h6>
                    <p className="m-0">{t(feature.desc)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="useCases" className="commonColor">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-6">
              <img
                src="/assets/img/usecasesMainImg.svg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="col-md-6">
              <div className="contentHeaderSection UseCasesHeaderSection">
                <div className="headerSpan">{t("use_cases")}</div>
                <h2 className="m-0 h2Class">{t("use_cases_title")}</h2>
                <p className="m-0 peraClass">{t("use_cases_desc")}</p>
              </div>
              <div className="useCaseContentSec">
                <img src="/assets/img/MarketingCampaigns.svg" alt="" />
                <p className="m-0">
                  <span>{t("marketing_campaigns")} </span>–{" "}
                  {t("marketing_campaigns_desc")}
                </p>
              </div>

              <div className="useCaseContentSec">
                <img src="/assets/img/OTPSecurity.svg" alt="" />
                <p className="m-0">
                  <span>{t("OTP_security")} </span>– {t("OTP_security_desc")}
                </p>
              </div>

              <div className="useCaseContentSec">
                <img src="/assets/img/TransactionaAlerts.svg" alt="" />
                <p className="m-0">
                  <span>{t("transactional_alerts")} </span>–{" "}
                  {t("transactional_alerts_desc")}
                </p>
              </div>

              <div className="useCaseContentSec">
                <img src="/assets/img/CustomerEngagement.svg" alt="" />
                <p className="m-0">
                  <span>{t("customer_engagement")} </span>–{" "}
                  {t("customer_engagement_desc")}
                </p>
              </div>

              <div className="useCaseContentSec">
                <img src="/assets/img/InternalCommunication.svg" alt="" />
                <p className="m-0">
                  <span>{t("internal_communication")} </span>–{" "}
                  {t("internal_communication_desc")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="steps">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12">
              <div className="contentHeaderSection">
                <div className="headerSpan">{t("steps")}</div>
                <h2 className="m-0 h2Class">{t("steps_title")}</h2>
                <p className="m-0 peraClass">{t("steps_title_desc")}</p>
              </div>
            </div>
          </div>

          <div className="row desktopView">
            <div className="col-md-12">
              <div className="outerStepsSection">
                <div className="stepSection">
                  <h6 className="m-0">{t("create_your_account")}</h6>
                  <p className="m-0">{t("create_your_account_desc")}</p>
                  <div className="imageBoxSec">
                    <img src="/assets/img/createAccount.svg" alt="" />
                  </div>
                  <h1 className="m-0">01</h1>
                </div>

                <div className="stepSection">
                  <h1 className="m-0">02</h1>
                  <div className="imageBoxSec">
                    <img src="/assets/img/ManageContacts.svg" alt="" />
                  </div>
                  <h6 className="m-0">{t("manage_your_contacts")}</h6>
                  <p className="m-0">{t("manage_your_contacts_desc")}</p>
                </div>

                <div className="stepSection">
                  <h6 className="m-0">{t("set_your_sender")}</h6>
                  <p className="m-0">{t("set_your_sender_desc")}</p>
                  <div className="imageBoxSec">
                    <img src="/assets/img/SenderID.svg" alt="" />
                  </div>
                  <h1 className="m-0">03</h1>
                </div>

                <div className="stepSection">
                  <h1 className="m-0">04</h1>
                  <div className="imageBoxSec">
                    <img src="/assets/img/ScheduleSMS.svg" alt="" />
                  </div>
                  <h6 className="m-0">{t("send_schedule_SMS")}</h6>
                  <p className="m-0">{t("send_schedule_SMS_desc")}</p>
                </div>

                <div className="stepSection">
                  <h6 className="m-0">{t("track_optimize")}</h6>
                  <p className="m-0">{t("track_optimize_desc")}</p>
                  <div className="imageBoxSec">
                    <img src="/assets/img/TrackOptimize.svg" alt="" />
                  </div>
                  <h1 className="m-0">05</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="row visibleMobile">
            <div className="col-md-12">
              <div className="outerStepsSection">
                <div className="stepSection">
                  <h1 className="m-0">01</h1>
                  <div className="imageBoxSec">
                    <img src="/assets/img/createAccount.svg" alt="" />
                  </div>
                  <h6 className="m-0">{t("create_your_account")}</h6>
                  <p className="m-0">{t("create_your_account_desc")}</p>
                </div>

                <div className="stepSection">
                  <h1 className="m-0">02</h1>
                  <div className="imageBoxSec">
                    <img src="/assets/img/ManageContacts.svg" alt="" />
                  </div>
                  <h6 className="m-0">{t("manage_your_contacts")}</h6>
                  <p className="m-0">{t("manage_your_contacts_desc")}</p>
                </div>

                <div className="stepSection">
                  <h1 className="m-0">03</h1>
                  <div className="imageBoxSec">
                    <img src="/assets/img/SenderID.svg" alt="" />
                  </div>
                  <h6 className="m-0">{t("set_your_sender")}</h6>
                  <p className="m-0">{t("set_your_sender_desc")}</p>
                </div>

                <div className="stepSection">
                  <h1 className="m-0">04</h1>
                  <div className="imageBoxSec">
                    <img src="/assets/img/ScheduleSMS.svg" alt="" />
                  </div>
                  <h6 className="m-0">{t("send_schedule_SMS")}</h6>
                  <p className="m-0">{t("send_schedule_SMS_desc")}</p>
                </div>
                <div className="stepSection">
                  <h1 className="m-0">05</h1>
                  <div className="imageBoxSec">
                    <img src="/assets/img/TrackOptimize.svg" alt="" />
                  </div>
                  <h6 className="m-0">{t("track_optimize")}</h6>
                  <p className="m-0">{t("track_optimize_desc")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="pricing" className="pricingSection">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12">
              <div className="contentHeaderSection">
                <div className="headerSpan">{t("pricing")}</div>
                <h2 className="m-0 h2Class">
                  {t("pricing_title_start")}{" "}
                  <span className="pricingTitleHighlight">
                    {t("pricing_title_highlight")}
                  </span>
                </h2>
                <p className="m-0 peraClass">{t("pricing_desc")}</p>
              </div>
            </div>
          </div>

          <div className="row pricingTopRow">
            <div className="col-lg-6 pricingIllustrationCol" />
            <div className="col-lg-6">
              <div className="pricingCalculator">
                <div className="calcHeader">
                  <div className="calcHeaderIcon">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="4" y="2" width="16" height="20" rx="2" />
                      <path d="M8 6h8M8 11h.01M12 11h.01M16 11h.01M8 15h.01M12 15h.01M16 15h.01M8 19h.01M12 19h.01M16 19h.01" />
                    </svg>
                  </div>
                  <div>
                    <h5 className="m-0">{t("pricing_calculator")}</h5>
                    <p className="m-0">{t("pricing_calculator_desc")}</p>
                  </div>
                </div>

                <div className="calcInputGroup">
                  <label htmlFor="smsCount">{t("number_of_sms")}</label>
                  <div className="calcStepper">
                    <button
                      type="button"
                      className="calcStepBtn"
                      aria-label="-"
                      disabled={smsCount <= 0}
                      onClick={() =>
                        setSmsCount((c) => Math.max(0, c - SMS_STEP))
                      }
                    >
                      <span>−</span>
                    </button>
                    <input
                      id="smsCount"
                      type="number"
                      min="0"
                      value={smsCount}
                      onChange={(e) =>
                        setSmsCount(
                          Math.max(0, parseInt(e.target.value, 10) || 0)
                        )
                      }
                    />
                    <button
                      type="button"
                      className="calcStepBtn"
                      aria-label="+"
                      onClick={() => setSmsCount((c) => c + SMS_STEP)}
                    >
                      <span>+</span>
                    </button>
                  </div>
                </div>

                <div className="calcRow">
                  <span>{t("plan")}</span>
                  <span className="calcPlan">{t(selectedPlan.key)}</span>
                </div>
                <div className="calcRow">
                  <span>{t("price_per_sms")}</span>
                  <span className="calcPrice">Kz {formatKz(pricePerSms)}</span>
                </div>
                <div className="calcRow">
                  <span>{t("subtotal")}</span>
                  <span>Kz {formatKz(subtotal)}</span>
                </div>
                <div className="calcRow">
                  <span>
                    {t("vat")} (14%)
                    <span className="calcInfo" title={t("vat_info")}>
                      i
                    </span>
                  </span>
                  <span>Kz {formatKz(vatAmount)}</span>
                </div>
                <div className="calcTotal">
                  <strong>{t("total_with_vat")}</strong>
                  <span>Kz {formatKz(totalWithVat)}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-4">
            {pricingPlans.map((plan) => {
              const style = planStyles[plan.key];
              return (
                <div className="col-lg-3 col-md-6" key={plan.key}>
                  <div
                    className={`pricingOuterSec${
                      style.featured ? " featured" : ""
                    }`}
                  >
                    <div className="planHeader">
                      <div className={`planIcon ${style.color}`}>
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          {style.icon}
                        </svg>
                      </div>
                      <div>
                        <h6 className="m-0">{t(plan.key)}</h6>
                        <p className="m-0">{t(style.tagline)}</p>
                      </div>
                    </div>

                    <div className="planPrice">
                      Kz <span>{plan.price}</span> <small>/ SMS</small>
                    </div>

                    {[
                      plan.range.type === "up_to"
                        ? `${t("up_to")} ${plan.range.value}`
                        : plan.range.value,
                      ...plan.features.map((feature) => t(feature)),
                    ].map((text, i) => (
                      <div className="planFeature" key={i}>
                        <span className="planCheck">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                        </span>
                        <p className="m-0">{text}</p>
                      </div>
                    ))}

                    <Link
                      to="https://app.smshubangola.com/"
                      target="_blank"
                      rel="noreferrer"
                      className="planBtnLink"
                    >
                      <div className="planBtn">
                        {t("get_started")}
                        <span aria-hidden="true">→</span>
                      </div>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section id="cta">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12">
              <div className="ctaBannerOuter">
                <div className="contentHeaderSection">
                  <div className="headerSpan">{t("CTA")}</div>
                  <h2 className="m-0 h2Class">{t("CTA_title")}</h2>
                  <p className="m-0 peraClass">{t("CTA_desc")}</p>

                  <div className="CtaButtonSection">
                    <Link
                      to="https://app.smshubangola.com/"
                      target="_blank"
                      rel="noreferrer"
                      className="getStartedbtnLink"
                    >
                      <button className="getStartedBtn">
                        <img src="/assets/img/energy.svg" alt="" />
                        {t("get_started_now")}
                      </button>
                    </Link>
                    <Link
                      to="https://app.smshubangola.com/"
                      target="_blank"
                      rel="noreferrer"
                      className="getStartedbtnLink"
                    >
                      <button className="requestBtn">
                        <img src="/assets/img/opening-times.svg" alt="" />
                        {t("request_demo")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
